import React, { useEffect, useState } from 'react';
import {
  Container,
  TextField,
  MenuItem,
  Button,
  Typography,
  Box,
} from '@mui/material';
import axios from 'axios';
import SuperAdminLayout from '../../../layouts/SuperAdminLayout';
import { useNavigate } from 'react-router-dom';
import api from '../../../utils/api';

const CreateReceipt = () => {
  const user = JSON.parse(localStorage.getItem('user'));
  const superAdminId = user?.id;
  const navigate = useNavigate();

  const [customers, setCustomers] = useState([]);
  const [form, setForm] = useState({
    date: new Date().toISOString().split('T')[0],
    partyName: '',
    paymentType: '',
    amount: '',
    remarks: '',
  });

  useEffect(() => {
    const fetchCustomers = async () => {
      try {
        const res = await api.get(`/api/customers/get-all/${superAdminId}`);
        setCustomers(res.data);
      } catch (err) {
        console.error('Failed to load customers:', err);
      }
    };
    fetchCustomers();
  }, [superAdminId]);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async () => {
    try {
      const payload = { ...form, superAdminId };
      await api.post(`/api/receipts/create`, payload);
      alert('Receipt created successfully!');
      navigate('/super-admin/receipt/view');
    } catch (err) {
      console.error('Error submitting receipt:', err);
      alert('Failed to create receipt.');
    }
  };

  return (
    <SuperAdminLayout>
      <Container maxWidth="screen" sx={{ mt: 4 }}>
        <Typography variant="h6" gutterBottom>
          Create Receipt
        </Typography>
        <Box
          component="form"
          display="flex"
          flexDirection="row"
          alignItems="flex-start"
          gap={2}
          sx={{
            width: 'screen',
            mt: 3,
            overflowX: 'auto',
            p: 1,
          }}
        >
          <TextField
            type="date"
            name="date"
            label="Date"
            value={form.date}
            onChange={handleChange}
            InputLabelProps={{ shrink: true }}
            size="medium"
            sx={{ minWidth: 160 }}
          />
          <TextField
            select
            name="partyName"
            label="Party Name"
            value={form.partyName}
            onChange={handleChange}
            size="medium"
            sx={{ minWidth: 180 }}
          >
            {customers.map((c) => (
              <MenuItem key={c._id} value={c.partyName}>
                {c.partyName}
              </MenuItem>
            ))}
          </TextField>
          <TextField
            select
            name="paymentType"
            label="Payment Type"
            value={form.paymentType}
            onChange={handleChange}
            size="medium"
            sx={{ minWidth: 180 }}
          >
            <MenuItem value="Party Payment">Party Payment</MenuItem>
            <MenuItem value="Expense">Expense</MenuItem>
          </TextField>
          <TextField
            type="number"
            name="amount"
            label="Amount"
            value={form.amount}
            onChange={handleChange}
            size="medium"
            sx={{ minWidth: 120 }}
          />
          <TextField
            name="remarks"
            label="Remarks"
            value={form.remarks}
            onChange={handleChange}
            multiline
            rows={3}
            size="medium"
            sx={{ minWidth: 300 }}
          />
          <Button
            variant="contained"
            onClick={handleSubmit}
            sx={{ height: 'fit-content', mt: 1 }}
          >
            Save
          </Button>
        </Box>
      </Container>
    </SuperAdminLayout>
  );
};

export default CreateReceipt;
